const LOOPBACK_CALLBACK =
  /^http:\/\/(127\.0\.0\.1|\[::1\]):[0-9]{1,5}\/callback\?[^#]*$/;

/**
 * Restrict decision redirects to HTTP IP-literal loopback destinations at `/callback`.
 * Checking the response before navigation prevents a non-loopback URL from redirecting this page.
 */
export function isLoopbackCallbackUrl(url: string | null): url is string {
  return url !== null && LOOPBACK_CALLBACK.test(url);
}
